import { useShortlistParticipantService } from "apps/console/modules/program/workflow/associateProgram/shortlist/context";
import { useParticipantDetails } from "apps/myExperience/context/participantDetails";
import React from "react";
import { useParams } from "react-router-dom";
import { useRegDetail } from "shared/context/regDetail";

export function useMyExperienceshortlistService() {
  const service = useShortlistParticipantService();
  const { activityId = "", programParticipantId = "" } = useParams();
  const { getProgramDetails } = useParticipantDetails();
  const { id: registrationId } = useRegDetail();
  const [filters, setFilters] = React.useState<Array<string>>([]);
  const hasMultipleActivities = React.useMemo(() => {
    return service.activityOptions?.length > 1;
  }, [service.activityOptions]);

  React.useEffect(() => {
    if (!activityId && service.selectedActivity) {
      service.setSelectedActivity("");
    }
    if (service.data && service.activityOptions.length === 1 && !activityId) {
      service.selectedActivity !== service.activityOptions[0].value &&
        service.handleSetSelectedActivity(service.activityOptions[0].value);
    }
  }, [service, service.data, activityId, service.selectedActivity]);

  const programId = React.useMemo(() => {
    return programParticipantId && getProgramDetails(programParticipantId)?.id;
  }, [programParticipantId, getProgramDetails]);

  return {
    ...service,
    hasMultipleActivities,
    filters,
    setFilters,
    programId,
    registrationId,
    programParticipantId
  };
}
